import React from 'react';
import './Services.css';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const servicesData = [
    {
        icon: (
            <svg viewBox="0 0 24 24">
                <rect x="2" y="3" width="20" height="14" rx="2"/>
                <path d="M8 21h8M12 17v4"/>
            </svg>
        ),
        title: 'Веб-приложения',
        description: 'Корпоративные порталы, CRM-системы, образовательные платформы и SaaS-решения. Адаптивный интерфейс, высокая производительность.'
    },
    {
        icon: (
            <svg viewBox="0 0 24 24">
                <rect x="3" y="3" width="18" height="18" rx="2"/>
                <path d="M3 9h18M9 21V9"/>
            </svg>
        ),
        title: 'Десктоп-приложения',
        description: 'Кросс-платформенные приложения на Flutter, Electron. Работают на Windows, macOS, Linux без потери производительности.'
    },
    {
        icon: (
            <svg viewBox="0 0 24 24">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
            </svg>
        ),
        title: 'Интеграция систем',
        description: 'REST и WebSocket API, подключение к 1С, ERP, CRM и другим корпоративным системам. Синхронизация данных в реальном времени.'
    },
    {
        icon: (
            <svg viewBox="0 0 24 24">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.42A2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.5a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
        ),
        title: 'Образовательные платформы',
        description: 'Электронные журналы, системы тестирования, видеолекции, чаты и аналитика успеваемости. Опыт разработки собственной LMS.'
    },
    {
        icon: (
            <svg viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="3"/>
                <path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/>
            </svg>
        ),
        title: 'ИИ и автоматизация',
        description: 'Интеграция языковых моделей, автоматизация рутинных процессов, умные рекомендации и анализ данных на основе ML.'
    },
    {
        icon: (
            <svg viewBox="0 0 24 24">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
        ),
        title: 'DevOps и поддержка',
        description: 'Настройка CI/CD, мониторинг, резервное копирование и техническая поддержка 24/7. Масштабирование под рост нагрузки.'
    }
];

function ServiceCard({ service }) {
    const cardRef = useScrollAnimation();

    return (
        <div className="service-card" ref={cardRef}>
            <div className="service-icon">
                {service.icon}
            </div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
        </div>
    );
}

function Services() {
    return (
        <section className="section" id="services">
            <div className="section-inner">
                <span className="section-label">Что мы делаем</span>
                <h2 className="section-title">Полный цикл разработки<br />и интеграции</h2>
                <p className="section-sub">
                    От анализа задачи до запуска в продакшен — берём на себя полный цикл, либо интегрируемся в ваш процесс на любом этапе.
                </p>

                <div className="services-grid">
                    {servicesData.map((service, index) => (
                        <ServiceCard service={service} key={index} />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Services;